import styled, { spacing } from "@rentiohq/web-theme";

export const Wrapper = styled.div`
  margin: 0 -${spacing("tight")};
  padding: ${spacing("tight")};
  &:hover {
    background: ${props => props.theme.colors.neutral10};
  }
`;
